import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';
import { copyTextBankActions } from '../../actions/constant';
import copyTextBankService from 'src/services/copytextBankService/copyTextBankService';

const { REQUEST_SEARCH_CPT_CODES, SUCCESS_SEARCH_CPT_CODES, FAILURE_SEARCH_CPT_CODES } =
  copyTextBankActions;

function* getDescription(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(copyTextBankService.getCPTCodesDescription, payload.cptCode);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_SEARCH_CPT_CODES, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_SEARCH_CPT_CODES, payload: error });
  }
}

function* getCPTCodesDescriptionSaga() {
  yield takeEvery(REQUEST_SEARCH_CPT_CODES, getDescription);
}

export default getCPTCodesDescriptionSaga;
